import React from 'react';
import { HelpCircle, Clock } from 'lucide-react';
import { InterviewQuestion } from '../../dto/videoInterviewDto';

interface QuestionListProps {
    questions: InterviewQuestion[];
}

export default function QuestionList({ questions }: QuestionListProps) {
    return (
        <div className="h-full flex flex-col bg-card border-l border-border">
            <div className="p-6 border-b border-border bg-muted/50">
                <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
                    <HelpCircle className="w-6 h-6 text-[#1b237a]" />
                    Interview Questions
                </h2>
                <p className="text-sm text-muted-foreground mt-1">
                    Please answer the questions below in your video response.
                </p>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-4">
                {questions.map((q, index) => (
                    <div
                        key={q.id}
                        className="p-4 rounded-xl border border-border bg-card shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group"
                    >
                        <div className="absolute top-0 left-0 w-1 h-full bg-[#1b237a] opacity-0 group-hover:opacity-100 transition-opacity" />

                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-50 text-[#1b237a] flex items-center justify-center font-bold text-sm">
                                {index + 1}
                            </div>
                            <div className="flex-1">
                                <p className="text-foreground font-medium leading-relaxed">
                                    {q.text}
                                </p>
                                {q.timeLimitSeconds && (
                                    <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
                                        <Clock className="w-3.5 h-3.5" />
                                        <span>Recommended time: {q.timeLimitSeconds}s</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}

                {questions.length === 0 && (
                    <div className="text-center py-12 text-muted-foreground">
                        <p>No questions available.</p>
                    </div>
                )}
            </div>

            <div className="p-4 bg-muted border-t border-border text-xs text-center text-muted-foreground">
                Good luck with your interview!
            </div>
        </div>
    );
}
